import { lazy } from "react";
import Loadable from "app/components/Loadable";


const Redemption = Loadable(lazy(() => import("./Redemption")));

const redemptionRoutes = [
    { path: "redemption", element: <Redemption /> },
  ];
  
  export default redemptionRoutes;